import { Stack, Box, Typography, Paper, Chip } from "@mui/material";
import type { ConfigShowData } from "@/admin/entities/configs";
import { CustomCellDate } from "@/shared/components";

interface ConfigDetailsProps {
  config: ConfigShowData;
}

export function ConfigDetails({ config }: ConfigDetailsProps) {
  if (!config) {
    return (
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" color="error">
          Запись не найдена
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">{config.key}</Typography>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Значение
          </Typography>
          <Typography
            variant="body1"
            component="pre"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {config.value ?? "—"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            ID
          </Typography>
          <Typography variant="body1">{config.id}</Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Создан
          </Typography>
          <CustomCellDate date={config.createdAt} />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Обновлён
          </Typography>
          <CustomCellDate date={config.updatedAt} />
        </Box>

        {config.deletedAt ? (
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Статус
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip label="Удалён" color="warning" size="small" />
              <CustomCellDate date={config.deletedAt} />
            </Stack>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
}
